import APIManager from 'api/APIManager';
import APIConstant from 'api/APIConstant';
import { parameterToPath } from 'utils';

export type Popup = {
  popup_id?: number; // 팝업 idx
  popup_name?: string; // 팝업명
  show_channel?: { [key: string]: string | number }; // 노출 채널
  is_show?: string; // 노출 여부
  start_date?: number; // 노출 시작일
  end_date?: number; // 노출 종료일
  popup_content?: string; // 팝업내용
  show_page?: { [key: string]: string | number }; // 노출 페이지 설정
  window_width?: number; // 창 넓이
  window_height?: number; // 창 높이
  window_x?: number; // 창 x축 위치
  window_y?: number; // 창 y축 위치
  show_platform?: string; // 노출 플랫폼
  created_at?: number; // 생성일
  updated_at?: number; // 수정일
};

const $http = new APIManager();

const Api = {
  /**
   * [GETS] Popup
   * --
   */
  getPopups: async (params?: { [key: string]: string | number }) => {
    try {
      const res = await $http.get(APIConstant.GETS_POPUP, params);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [GET] Popup
   * --
   */
  getPopup: async (
    idx: number,
    params?: { [key: string]: string | number }
  ) => {
    try {
      const url = parameterToPath(APIConstant.GET_POPUP, { popup_id: idx });
      const res = await $http.get(url, params);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [POST] Popup
   * --
   */
  createPopup: async (body: Popup) => {
    try {
      const res = await $http.post(APIConstant.CREATE_POPUP, body);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [PUT] Popup
   * --
   */
  updatePopup: async (body: Popup) => {
    try {
      const { popup_id } = body;
      const url = parameterToPath(APIConstant.UPDATE_POPUP, {
        popup_id: popup_id,
      });

      const res = await $http.put(url, body);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [DELETE] Popup
   * --
   */
  deletePopup: async (idx: number) => {
    try {
      const url = parameterToPath(APIConstant.UPDATE_POPUP, {
        popup_id: idx,
      });

      const res = await $http.delete(url);

      return res;
    } catch (e) {
      throw e;
    }
  },
};

export default Api;
